export type EmailRequirementState = 'submitted' | 'completed' | 'rejected';

export const EmailRequirementState = {
  Submitted: 'submitted' as EmailRequirementState,
  Completed: 'completed' as EmailRequirementState,
  Rejected: 'rejected' as EmailRequirementState
};